import {fetch, fetchAjax} from '@/utils/index'
import API from './api'
import hhkjsq from '@/common/hhkjsq.js'
import $ from 'zepto'
const {appInfo, isAndroid, isIPhone, app} = hhkjsq

// 默认加载的信息数量
const DEFAULT_PAGE_SIZE = 30

// 默认畅说留言类别
const DEFAULT_INFO_TYPE = 2031

// 默认回复ID
const DEFAULT_POSITION_ID = 0

// 默认排序1升序， 3降序
const DEFAULT_ORDER_BY = 3

// 默认首次加载的页数
const DEFAULT_INIT_PADE_INDEX = 1

const DEFAULT_CITY_ID = 2

function getSource () {
  if (isAndroid) {
    return 4
  } else if (isIPhone) {
    return 5
  }
}

// 获取各种评论列表的工厂函数
function fetchFactory (url) {
  var getRequestData = function (data) {
    return {
      infoID: data.infoID,
      infoType: data.infoType || DEFAULT_INFO_TYPE,
      pageIndex: data.pageIndex || DEFAULT_INIT_PADE_INDEX,
      pageSize: data.pageSize || DEFAULT_PAGE_SIZE,
      positionID: data.positionID || DEFAULT_POSITION_ID,
      orderBy: data.orderBy || DEFAULT_ORDER_BY
    }
  }
  return function (params) {
    return fetch({
      url: url,
      data: getRequestData(params),
      dataType: 'jsonp'
    })()
  }
}

export function initAllList2 (options) {
  options.params = Object.assign({}, {
    infoType: DEFAULT_INFO_TYPE,
    pageIndex: DEFAULT_INIT_PADE_INDEX,
    pageSize: DEFAULT_PAGE_SIZE,
    positionID: DEFAULT_POSITION_ID,
    orderBy: DEFAULT_ORDER_BY
  }, options.params)
  options.url = API.GET_ALL_COMMENT_LIST
  getJsonp(options)
}

export function initEliteList2 (options) {
  options.params = Object.assign({}, {
    infoType: DEFAULT_INFO_TYPE,
    pageIndex: DEFAULT_INIT_PADE_INDEX,
    pageSize: DEFAULT_PAGE_SIZE,
    positionID: DEFAULT_POSITION_ID,
    orderBy: DEFAULT_ORDER_BY
  }, options.params)
  options.url = API.GET_ELITE_COMMENT_LIST
  getJsonp(options)
}
// 首次加载直播‘全部’列表
export const initAllList = fetchFactory(API.GET_ALL_COMMENT_LIST)

// 首次加载直播‘只看精华’列表
export const initEliteList = fetchFactory(API.GET_ELITE_COMMENT_LIST)

export const getMoreAllList = function (params) {
  let defaultParams = {
    infoType: DEFAULT_INFO_TYPE,
    topNum: DEFAULT_PAGE_SIZE,
    minCommentId: 0,
    maxCommentId: 0
  }
  params = Object.assign({}, defaultParams, params)
  return fetch({
    url: API.GET_TOP_NUM_COMMENT_LIST,
    data: params,
    dataType: 'jsonp'
  })()
}

export const getMoreAllList2 = function (options) {
  let defaultParams = {
    infoType: DEFAULT_INFO_TYPE,
    topNum: DEFAULT_PAGE_SIZE,
    minCommentId: 0,
    maxCommentId: 0
  }
  options.params = Object.assign({}, defaultParams, options.params)
  options.url = API.GET_TOP_NUM_COMMENT_LIST
  getJsonp(options)
}

// 发布评论
export const pubComment = function (params) {
  return fetchAjax({
    url: API.POST_COMMENT,
    type: 'POST',
    data: {
      InfoID: params.InfoID,
      infoType: DEFAULT_INFO_TYPE,
      ComTxt: params.ComTxt,
      InfoMemo: params.InfoMemo || '',
      TopicUserName: params.TopicUserName,
      UserID: params.UserID,
      PreCommentID: params.PreCommentID,
      Source: getSource(),
      WebSiteID: appInfo.cityId || DEFAULT_CITY_ID,
      ImagePath: params.ImagePath || ''
    }
  })()
}

export const pubComment2 = function (options) {
  options.params = Object.assign({}, {
    infoType: DEFAULT_INFO_TYPE,
    InfoMemo: '空',
    Source: getSource(),
    WebSiteID: appInfo.cityId || DEFAULT_CITY_ID,
    ImagePath: ''
  }, options.params)
  options.type = 'POST'
  options.url = API.POST_COMMENT
  options.isNeedDecode = true
  appAjax(options)
}

function appAjax (options) {
  app.ajax({
    url: options.url,
    params: options.params,
    type: options.type || 'GET',
    isNeedDecode: options.isNeedDecode || false,
    success: function (response) {
      options.success && options.success(response)
    },
    error: function (error) {
      options.error && options.error(error)
    },
    complete: function () {
      options.complete && options.complete()
    }
  })
}

function getJsonp (options) {
  $.ajax({
    url: options.url,
    data: options.params,
    dataType: 'jsonp',
    success: function (response) {
      options.success && options.success(response)
    },
    error: function (error) {
      options.error && options.error(error)
    },
    complete: function () {
      options.complete && options.complete()
    }
  })
}

// 点赞
export const pubPraise = function (params) {
  return fetchAjax({
    url: API.POST_PRAISE,
    type: 'POST',
    data: {
      InfoID: params.InfoID,
      InfoType: DEFAULT_INFO_TYPE,
      InfoMemo: params.InfoMemo || '',
      TopicUserName: params.TopicUserName,
      TopicUserID: params.TopicUserID || 0,
      Source: getSource()
    }
  })()
}

export const pubPraise2 = function (options) {
  options.params = Object.assign({}, {
    InfoType: DEFAULT_INFO_TYPE,
    InfoMemo: '空',
    TopicUserID: 0,
    Source: getSource()
  }, options.params)
  options.type = 'POST'
  options.url = API.POST_PRAISE
  appAjax(options)
}

export const getPostInfo = function ({id}) {
  return fetch({
    url: API.GET_POST_BY_ID,
    type: 'GET',
    dataType: 'jsonp',
    data: {
      id: id
    }
  })()
}

export function getPostInfo2 (options) {
  options.url = API.GET_POST_BY_ID
  getJsonp(options)
}

// 取消点赞
export const delPraise = function (params) {
  return fetchAjax({
    url: API.DEL_PRAISE_INFO,
    type: 'GET',
    data: {
      InfoType: DEFAULT_INFO_TYPE,
      InfoID: params.InfoID
    }
  })()
}

export function delPraise2 (options) {
  options.params = Object.assign({}, {
    InfoType: DEFAULT_INFO_TYPE
  }, options.params)
  options.url = API.DEL_PRAISE_INFO
  appAjax(options)
}

// 获取列表赞的信息
export const getPraiseInfoList = function (params) {
  return fetchAjax({
    url: API.PRAISE_LIST,
    type: 'GET',
    data: {
      InfoType: DEFAULT_INFO_TYPE,
      InfoIDs: params.InfoIDs
    }
  })()
}

export function getPraiseInfoList2 (options) {
  options.params = Object.assign({}, {
    InfoType: DEFAULT_INFO_TYPE
  }, options.params)
  options.url = API.PRAISE_LIST
  appAjax(options)
}

export const getUserHeadUrl = function (id) {
  return API.GET_HEAD_PIC(id)
}

export const getUserHomeUrl = function (name) {
  return API.GET_USER_HOME(name)
}



// WEBPACK FOOTER //
// ./src/api/actions.js